import React, { Fragment, useState } from "react";
import { isMobile } from "react-device-detect";
import { Dialog } from "@material-ui/core";
import MasterTaskForm from "./MasterTaskForm";
import { DownloadMcSampleFile, DownloadMcTemplateFile } from "../apiServices";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo } from "../../../../utils";
import CamoCTA from "../../../../shared_elements/components/cta/CamoCTA";

const MasterSearchBar = ({ applyingFilter, tabIndex, pageLoader, props, searchData, fileUploadData, importFile, exportReportFn, currentRecordPerPage, uuid, getResponseBack, basicDetails }) => {
	const [open, setOpen] = useState(false);
	const [formTitle, setFormTitle] = useState("");
	const [actionType, setActionType] = useState("");

	const addNewTask = () => {
		setOpen(true);
		setFormTitle("Master Components");
		setActionType("add");
	};

	const importFileFunc = (e) => {
		const files = e.target.files;
		const formData = new FormData();
		formData.append("file", files[0]);
		importFile(formData, props, true);
		e.target.value = null;
	};

	const filterParams = convertFilterObject(removeEmptyKey(applyingFilter));

	return (
		<Fragment>
			<div id="AmpSearchBar">
				<CamoCTA
					searchPlaceholder="Search By Part Number, Serial Number, Description"
					onSearch={(value) => searchData({ target: { value } })}
					permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
					addLabel="ADD MASTER COMPONENT"
					onAddFn={addNewTask}
					onImportFn={importFileFunc}
					exportMenu={{
						exportReportFn: exportReportFn,
						files: [
							{ title: 'PDF', extension: 'pdf', key: '' },
							{ title: 'EXCEL', extension: 'xlsx', key: '' },
						],
					}}
					downloadSampleMenu={{
						exportReportFn: (file) => file.key === 'template'
							? DownloadMcTemplateFile({ download: file.extension, ...filterParams }, pageLoader, props, basicDetails)
							: DownloadMcSampleFile({ download: file.extension, ...filterParams }, pageLoader, props, basicDetails),
						files: [
							{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', key: 'sample' },
							{ title: 'TEMPLATE', extension: 'xlsx', key: 'template' },
						],
					}}
				/>
				<Dialog open={open} style={{ height: isMobile && "650px" }}>
					<MasterTaskForm
						formTitle={formTitle}
						closeAddForm={() => setOpen(false)}
						addForm={() => setOpen(true)}
						props={props}
						actionType={actionType}
						fileUploadData={fileUploadData}
						currentRecordPerPage={currentRecordPerPage}
						uuid={uuid}
						getResponseBack={() => getResponseBack()}
					/>
				</Dialog>
			</div>
		</Fragment>
	);
};

export default MasterSearchBar;
